import { Modal, TinyButton, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import { Mandator } from 'ComponentLibrary/src/molecules/MandatorList/types'
import { MandatorForm, type MandatorFormLabels } from './MandatorForm'
import { MandatorListItem, type MandatorListItemCopy } from './MandatorListItem'
import { PlusIcon } from '@phosphor-icons/react'

type MandatorListProps = {
    mandators: Mandator[]
    isAddMandatorFormOpen: boolean
    setIsAddMandatorFormOpen: (isOpen: boolean) => void
    addMandator: (mandator: Mandator) => void
    updateMandator: (index: number, mandator: Mandator) => void
    deleteMandator: (index: number) => void
    copy: MandatorListCopy
}

export type MandatorListCopy = {
    addButtonLabel: string
    addModalTitle: string
    item: MandatorListItemCopy
    formLabels: MandatorFormLabels
}

export const MandatorList = ({
    mandators,
    isAddMandatorFormOpen,
    setIsAddMandatorFormOpen,
    addMandator,
    updateMandator,
    deleteMandator,
    copy,
}: MandatorListProps) => {
    const handleFormSubmit = (mandator: Mandator) => {
        addMandator(mandator)
        setIsAddMandatorFormOpen(false)
    }

    const handleFormCancel = () => {
        setIsAddMandatorFormOpen(false)
    }

    return (
        <Stack direction="column" marginTop="0px">
            {mandators.length === 0 && (
                <TinyButton onClick={() => setIsAddMandatorFormOpen(true)} label={copy.addButtonLabel} leftIcon={<PlusIcon />} />
            )}
            {isAddMandatorFormOpen && (
                <Modal isOpen={isAddMandatorFormOpen} onClose={handleFormCancel} title={copy.addModalTitle}>
                    <MandatorForm onCancelCallback={handleFormCancel} onSubmitCallback={handleFormSubmit} labels={copy.formLabels} />
                </Modal>
            )}
            <Stack direction="column" gap={tokens.SizingSpacing200}>
                {mandators.map((mandator, index) => (
                    <MandatorListItem
                        key={index}
                        mandator={mandator}
                        updateMandator={(mandator: Mandator) => updateMandator(index, mandator)}
                        deleteMandator={() => deleteMandator(index)}
                        copy={copy.item}
                    />
                ))}
            </Stack>
        </Stack>
    )
}
